"use strict";

exports.__esModule = true;
exports.validateAlertTags = exports.validateAlertTag = exports.validateAlertRules = void 0;
var _vimanaTypes = require("@vimana/vimana-types");
var _CommonValidators = require("./CommonValidators");
var tagForbidenCharacters = /\"/;
var validateAlertTag = exports.validateAlertTag = function validateAlertTag(alertName) {
  return !tagForbidenCharacters.test(alertName);
};
var validateAlertTags = exports.validateAlertTags = function validateAlertTags(tags) {
  return (tags == null ? void 0 : tags.length) > 0 ? tags.every(validateAlertTag) : true;
};
var validateAlertRules = exports.validateAlertRules = function validateAlertRules(alerts) {
  var result = true;
  alerts == null || alerts.forEach(function (alert) {
    if (result) {
      result = (0, _CommonValidators.validateEmptyField)(alert.description) && (0, _CommonValidators.validateEmptyField)(alert.alertName) && (0, _CommonValidators.validateAlertName)(alert.alertName) && validateAlertTags(alert.tags) && (0, _CommonValidators.validateConditions)(alert == null ? void 0 : alert.conditions);
    }
  });
  return result;
};